import React, { ChangeEvent, Component } from 'react'
import InputLabel from './InputLabel'
import InputIcon from './InputIcon'

export interface SelectOption {
  name: string
  value: string
  disabled?: boolean
}

interface SelectProps {
  name: string
  value: string
  options: SelectOption[]
  placeholder?: string
  label?: string
  widthAuto?: boolean
  onChange: (name: string, value: string) => void
}

export default class Select extends Component<SelectProps> {
  constructor (props: SelectProps) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  option (option: SelectOption) {
    return (
      <option
        value={option.value}
        key={option.value}
        disabled={option.disabled}>
        {option.name}
      </option>
    )
  }

  get className () {
    const base = 'form-select input-default appearance-none pr-8'
    const width = this.props.widthAuto && 'w-auto'
    return `${base} ${width}`
  }

  get options () {
    return this.props.options.map(option => this.option(option))
  }

  handleChange (event: ChangeEvent<HTMLSelectElement>) {
    const { name } = this.props
    const { value } = event.target
    this.props.onChange(name, value)
  }

  render () {
    return (
      <div className="block">
        <InputLabel text={this.props.label} />
        <InputIcon name="arrow-down-s">
          <select
            className={this.className}
            name={this.props.name}
            value={this.props.value}
            onChange={this.handleChange} >
            <option
              value=""
              disabled>
              {this.props.placeholder}
            </option>
            {this.options}
          </select>
        </InputIcon>
      </div>
    )
  }
}
